import type { EntityViewType } from "@config";
import "../styles/Array.scss";
import { ArrayCombo } from "../styles/Array.styled";

export const ArrayView = ({
  children,
}: {
  entity: EntityViewType;
  children: React.ReactNode;
}) => (
  <ArrayCombo className="combo arrayCombo tw-flex tw-max-w-full tw-flex-wrap [text-align:inherit]">
    {children}
  </ArrayCombo>
);
